import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'jquery-slimscroll';
import { AppState } from '../../../app.service';
import { PermissionService } from "../../../services/SecurityServices/permission.service";

declare var jQuery: any;

@Component({
    selector: 'navigation',
    template: require('./navigation.template.html')
})

export class NavigationComponent implements OnInit {

    private profileImage: string;
    private firstName: string;
    private lastName: string;
    private showUsers: boolean = false;
    private showCustomers: boolean = false;
    private showSites: boolean = false;
    private showLoyaltyTransactionLogs: boolean = false;
    private showFraudReports: boolean = false;
    private showAuditReports: boolean = false;
    private showMap:boolean = true;
    private sidebarImage: string;
    private sidebarImageMin: string;
    constructor(
        private router: Router,
        private appState: AppState,
        private permissionService: PermissionService
    ) { }

    ngOnInit() {
        this.setPermissions();
        this.profileImage = this.appState.getCookie("imageUrl");
        this.firstName = this.appState.getCookie("firstName");
        this.lastName = this.appState.getCookie("lastName");

        this.sidebarImage = `/assets/images/${process.env.program}/sidebar-logo.png`;
        this.sidebarImageMin = `/assets/images/${process.env.program}/sidebar-logo2.png`;
    }

    private setPermissions(): void {
        let self: NavigationComponent = this;
        this.showUsers = this.permissionService.userHasPermission('View_Users');
        this.showCustomers = this.permissionService.userHasPermission('View_Customers');
        this.showSites = this.permissionService.userHasPermission('View_Sites');
        this.showLoyaltyTransactionLogs = this.permissionService.userHasPermission('View_LoyaltyTransactionLogs');
        this.showFraudReports = this.permissionService.userHasPermission('View_FraudReports');
        this.showAuditReports = this.permissionService.userHasPermission('View_Audit_Search');
    }

    ngAfterViewInit() {
        jQuery('#side-menu').metisMenu();

        if (jQuery("body").hasClass('fixed-sidebar')) {
            jQuery('.sidebar-collapse').slimscroll({
                height: '100%'
            })
        }
    }

    public shouldHideLink(routeName: string): boolean {
        if (routeName != 'login') {
            return !this.appState.isLoggedIn();
        } else {
            return true;
        }
    }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) > -1;
    }


}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/components/common/navigation/navigation.component.ts